import { Rota } from '@finx/web-repository/src/types/Rotas'

const rotas: Array<Rota> = [
  {
    denied: ['PLANO_CALCULADORA'],
    icone: 'add_box',
    texto: 'Produção',
    url: '/producao',
    viewName: 'producao',
  },
  {
    denied: ['PLANO_CALCULADORA'],
    icone: 'assignment',
    texto: 'Recebimento',
    url: '/recebimento',
    viewName: 'recebimento',
  },
  {
    denied: ['PLANO_CALCULADORA'],
    icone: 'assessment',
    texto: 'Relatório',
    url: '/relatorio/fonte-pagadora',
    viewName: 'relatorio',
  },
  {
    hideOnMobile: true,
    icone: 'account_box',
    texto: 'Perfil',
    url: '/perfil',
    viewName: 'perfil',
  },
]

export default rotas
